import {EffectCallback, useEffect} from 'react';
import {useRoute} from '@react-navigation/native';
import {NavigationRouteProps} from '../routing/model';

export const useModifiedRouterParams = <P extends {[param: string]: any}>(
  fn: (params: P) => ReturnType<EffectCallback>,
) => {
  const route: NavigationRouteProps<P> = useRoute();
  useEffect(() => {
    const res = fn(route.params || {});

    if (res) {
      return res;
    }
  }, [route.params]);
};
